import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { LoaderSpinnerComponent } from "@aston/foundation/components";
import { RouterLinkActive, RouterLink } from '@angular/router';
import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Store } from '@ngrx/store';

import { FederationsStoreActions, FederationsStoreSelectors } from '../../../root-store/federations-store';
import * as RoutesDefinitions from '../../../routes-definitions';
import {AppStoreSelectors} from "../../../root-store/app-store";
import { AppConfiguration } from '../../../app.configuration';

@Component({
	selector: 'federation-validation-page',
	templateUrl: './federation-validation-page.component.html',
	imports: [LoaderSpinnerComponent, TranslateDirective, RouterLinkActive, RouterLink, AsyncPipe, TranslatePipe]
})
export class FederationValidationPageComponent {

	private config = inject(AppConfiguration);
	private store = inject(Store);

	currentUserIsSupport$ = this.store.select(AppStoreSelectors.selectCurrentUserIsSupport);
	federationIsNotReady$ = this.store.select(FederationsStoreSelectors.selectFederationEntityIsLoading);
	selectedFederation$ = this.store.select(FederationsStoreSelectors.selectFederationEntity);
	federationFormError$ = this.store.select(FederationsStoreSelectors.selectFederationEntityError);

	assetsPath = this.config.appRootUrl;

	goToFederation(federationId: number) {
		this.store.dispatch(FederationsStoreActions.RedirectTo({ federationId }));
	}

	federationDetailUsersPath(federationId: number) {
		return RoutesDefinitions.getFederationDetailUsersFullPath(federationId);
	}
}
